export default __webpack_public_path__ + "static/media/Paris.bf797924.jpg";